import { render, staticRenderFns } from "./itemCard.vue?vue&type=template&id=c99fffd4&scoped=true&"
import script from "./itemCard.vue?vue&type=script&lang=js&"
export * from "./itemCard.vue?vue&type=script&lang=js&"
import style0 from "./itemCard.vue?vue&type=style&index=0&id=c99fffd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99fffd4",
  null
  
)

export default component.exports